import React from 'react'
import { AtlasImageStyles } from '@utils/buildAtlasImageStyles'

interface ImageTemplateProps {
    image?: string
    imageStyles?: AtlasImageStyles
}

const ImageTemplate: React.FC<ImageTemplateProps> = ({ image, imageStyles }: ImageTemplateProps) => {
    if (image) {
        return <img src={image} alt="Bonus image" className="w-full h-[292px]" />
    } else if (imageStyles) {
        return <div className="w-full h-[292px]" style={imageStyles} />
    }
}

export default ImageTemplate
